import type { AgentConnection } from "../connection/agent-connection.js";
import type { AgentRunnerConfig } from "../types.js";
import { buildTaskContextTools } from "./task-context-tools.js";
import {
  buildGetDependenciesTool,
  buildGetSuggestionsTool,
} from "./dependency-suggestion-tools.js";
import { buildMutationTools } from "./mutation-tools.js";
import { buildUploadAttachmentTool } from "./attachment-tools.js";
import {
  buildApproveManualTestTool,
  buildEditManualTestTool,
  buildListManualTestsTool,
  buildQueryManualTestsTool,
  buildRejectManualTestTool,
  buildRemoveManualTestTool,
  buildSetManualTestsTool,
} from "./checklist-tools.js";

// Re-export individual builders for selective use
export {
  buildReadTaskChatTool,
  buildGetCurrentPlanTool,
  buildGetTaskTool,
  buildGetExecutionLogsTool,
  buildListTaskFilesTool,
  buildGetAttachmentTool,
} from "./task-context-tools.js";

export { buildForceUpdateTaskStatusTool } from "./mutation-tools.js";
export { buildUploadAttachmentTool } from "./attachment-tools.js";

// ── Aggregator ───────────────────────────────────────────────────────

export function buildCommonTools(connection: AgentConnection, config: AgentRunnerConfig) {
  return [
    ...buildTaskContextTools(connection),
    buildGetDependenciesTool(connection),
    buildGetSuggestionsTool(connection),
    buildListManualTestsTool(connection),
    buildQueryManualTestsTool(connection),
    buildSetManualTestsTool(connection),
    buildEditManualTestTool(connection),
    buildRemoveManualTestTool(connection),
    buildApproveManualTestTool(connection),
    buildRejectManualTestTool(connection),
    ...buildMutationTools(connection, config),
    buildUploadAttachmentTool(connection, config),
  ];
}
